<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Club data edit modal title@@clubComponent.workspaceTitle.editTixxWebshop'>Edit Tixx organiser</h3>
    <form [formGroup]="clubForm" (ngSubmit)="updateClub()" id="editTixxWebshopForm">
      <div app-form-field-text-generic
           [control]="clubForm.get('tixxWebshopConfiguration.client')"
           [label]="flTranslations.i18nTixxConnectionClient"
           [placeholder]="flTranslations.i18nTixxConnectionClient">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <app-submit-row-buttons [form]="'editTixxWebshopForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="clubOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
